import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty';

import { request } from '../common';

import { BASE_PATH } from './constants';

export type ListActionRewardConfigsResponse =
  paths['/api/lux-loyalty/points/action-reward-configs']['get']['responses']['200']['content']['application/json'];

export type ActionRewardConfig = ListActionRewardConfigsResponse['result'][number];

export type CreateActionRewardConfigRequestBody =
  paths['/api/lux-loyalty/points/action-reward-configs']['post']['requestBody']['content']['application/json'];

export type CreateActionRewardConfigResponse =
  paths['/api/lux-loyalty/points/action-reward-configs']['post']['responses']['201']['content']['application/json'];

export type UpdateActionRewardConfigRequestBody =
  paths['/api/lux-loyalty/points/action-reward-configs/{id}']['patch']['requestBody']['content']['application/json'];

export type UpdateActionRewardConfigResponse =
  paths['/api/lux-loyalty/points/action-reward-configs/{id}']['patch']['responses']['200']['content']['application/json'];

export type ActionRewardExcludeColumn = NonNullable<CreateActionRewardConfigRequestBody['excludeColumn']>;

export type ActionRewardConfigStatus = NonNullable<CreateActionRewardConfigRequestBody['status']>;

interface RequestOptions {
  signal?: AbortSignal;
}

export function listActionRewardConfigs(options: RequestOptions = {}): Promise<ListActionRewardConfigsResponse> {
  return request(`${BASE_PATH}/points/action-reward-configs`, {
    ...options,
    method: 'GET',
  });
}

export function createActionRewardConfig(
  params: CreateActionRewardConfigRequestBody,
): Promise<CreateActionRewardConfigResponse> {
  return request(`${BASE_PATH}/points/action-reward-configs`, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: { 'Content-Type': 'application/json' },
  });
}

export function updateActionRewardConfig(
  id: string,
  params: UpdateActionRewardConfigRequestBody,
): Promise<UpdateActionRewardConfigResponse> {
  return request(`${BASE_PATH}/points/action-reward-configs/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(params),
    headers: { 'Content-Type': 'application/json' },
  });
}
